module.exports = __webpack_public_path__ + "img/amh.4a34c82e.jpg";